export default __webpack_public_path__ + "static/media/download.a68b9439.svg";